import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import JoditReact from "jodit-react";
import katex from "katex";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";
import api from "../../../api";
import { toast } from "react-toastify";

const AddQuestion = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [message, setMessage] = useState(false);
  const [correct, setCorrect] = useState("");    
  const [selectedClass,setSelectedClass]=useState("")
  const [subject,setSubject]=useState("")
  const [subjects,setSubjects]=useState([])
  const [exams,setExams]=useState([])
  const [selectedExams, setSelectedExams] = useState([]);
  const [topic, setTopic] = useState("");
  const [topics, setTopics] = useState([]);
  const [difficulty, setDifficulty] = useState("");
  const [mode, setMode] = useState("exam");
  const questionContentRef = useRef(null);
  const answerContentRef = useRef(null);
  const option1Ref=useRef(null)
  const option2Ref=useRef(null)
  const option3Ref=useRef(null)
  const option4Ref=useRef(null)
  const [options,setOptions]=useState([option1Ref,option2Ref,option3Ref,option4Ref])
  const [editorKey, setEditorKey] = useState(Date.now());
  const [examsLoading,setExamsLoading]=useState(false)
  const [addLoading,setAddLoading]=useState(false)
  const editorConfig2={
    readonly: false,
    tabIndex: 1,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    placeholder: "Type your description here ...",
    beautyHTML: true,
    toolbarButtonSize: "small",
    addNewLine: false,
    buttons: [
      "bold",
      "italic",
      'subscript', 
      'superscript',
      "|",
      "font",
      "fontsize",
      "table",
      "|",
    ],
    extraButtons: [
      // {
      //   name: "image",
      //   tooltip: "Insert Image",
      //   exec: (editor) => {
      //     const input = document.createElement("input");
      //     input.type = "file";
      //     input.accept = "image/*";
      //     input.addEventListener("change", async (e) => {
      //       const file = e.target.files[0]; // Get the file from the input

      //       if (file) {
      //         // Create FormData to send the file to the backend
      //         const formData = new FormData();
      //         formData.append("file", file); // Append the image file

      //         try {
      //           // Send the image to the backend server
      //           const response = await axios.post(`${baseUrl}/question/upload-image`, formData, {
      //             headers: {
      //               "Content-Type": "multipart/form-data", // Ensure the correct content type
      //             },
      //           });

      //           const imageUrl = response.data.url;

      //           // Insert the uploaded image URL into the Jodit editor
      //           editor.selection.insertImage(imageUrl);
      //         } catch (err) {
      //           console.error("Error uploading image:", err);
      //         }
      //       }
      //     });
      //     input.click();
      //   },
      // },
      {
        name: "symbols",
        icon: "fa fa-smile-o",
        tooltip: "Insert Symbol",
        exec: (editor) => {
          // Define the custom symbols
          const customSymbols = [
            { symbol: '€', title: 'Euro' },
            { symbol: '£', title: 'Pound Sterling' },
            { symbol: '¥', title: 'Yen' },
            { symbol: '₹', title: 'Indian Rupee' },
            { symbol: '$', title: 'Dollar' },
            { symbol: '₣', title: 'Franc' },
            { symbol: '₣', title: 'Lira (Turkish)' },
            { symbol: '±', title: 'Plus-Minus' },
            { symbol: '÷', title: 'Division Sign' },
            { symbol: '×', title: 'Multiplication Sign' },
            { symbol: '≠', title: 'Not Equal' },
            { symbol: '≈', title: 'Approximate Equal' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '√', title: 'Square Root' },
            { symbol: 'π', title: 'Pi' },
            { symbol: '∑', title: 'Summation' },
            { symbol: '∏', title: 'Product' },
            { symbol: '∈', title: 'Element Of' },
            { symbol: '∩', title: 'Intersection' },
            { symbol: '∪', title: 'Union' },
            { symbol: '∧', title: 'Logical AND' },
            { symbol: '∨', title: 'Logical OR' },
            { symbol: 'α', title: 'Alpha' },
            { symbol: 'β', title: 'Beta' },
            { symbol: 'γ', title: 'Gamma' },
            { symbol: 'δ', title: 'Delta' },
            { symbol: 'ε', title: 'Epsilon' },
            { symbol: 'λ', title: 'Lambda' },
            { symbol: 'μ', title: 'Mu' },
            { symbol: 'σ', title: 'Sigma' },
            { symbol: 'τ', title: 'Tau' },
            { symbol: 'φ', title: 'Phi' },
            { symbol: 'Ω', title: 'Omega' },
            { symbol: '©', title: 'Copyright' },
            { symbol: '®', title: 'Registered Trademark' },
            { symbol: '™', title: 'Trademark' },
            { symbol: '♥', title: 'Heart' },
            { symbol: '★', title: 'Star' },
            { symbol: '☼', title: 'Sun' },
            { symbol: '☽', title: 'Crescent Moon' },
            { symbol: '☃', title: 'Snowman' },
            { symbol: '☠', title: 'Skull and Crossbones' },
            { symbol: '✈', title: 'Airplane' },
            { symbol: '⚡', title: 'High Voltage' },
            { symbol: '✿', title: 'Flower' },
            { symbol: '☘', title: 'Shamrock' },
            { symbol: '☀', title: 'Sun Symbol' },
            { symbol: '☁', title: 'Cloud Symbol' },
            { symbol: '☂', title: 'Umbrella Symbol' },
            { symbol: '→', title: 'Right Arrow' },
            { symbol: '←', title: 'Left Arrow' },
            { symbol: '↑', title: 'Up Arrow' },
            { symbol: '↓', title: 'Down Arrow' },
            { symbol: '↔', title: 'Left-Right Arrow' },
            { symbol: '↕', title: 'Up-Down Arrow' },
            { symbol: '↗', title: 'Up-Right Arrow' },
            { symbol: '↖', title: 'Up-Left Arrow' },
            { symbol: '§', title: 'Section Symbol' },
            { symbol: '¶', title: 'Paragraph Symbol' },
            { symbol: '°', title: 'Degree Symbol' },
            { symbol: '≡', title: 'Identical To' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '≠', title: 'Not Equal' }
          ];
          

          // Build the HTML content for the custom symbols
          const symbolButtons = customSymbols
            .map(
              (symbol) =>
                `<button class="jodit-symbol-btn" title="${symbol.title}" onclick="insertSymbol('${symbol.symbol}')">${symbol.symbol}</button>`
            )
            .join(" ");

          // Show a modal to select a symbol
          const modal = document.createElement('div');
          modal.classList.add('jodit-symbol-modal');
          modal.innerHTML = `
            <div class="jodit-symbol-modal-content">
              <h3>Select a Symbol</h3>
              <div class="symbol-buttons">${symbolButtons}</div>
              <button class="jodit-close-btn">Close</button>
            </div>
          `;
          document.body.appendChild(modal);

          // Close modal handler
          modal.querySelector('.jodit-close-btn').addEventListener('click', () => {
            document.body.removeChild(modal);
          });

          // Insert the symbol into the editor
          window.insertSymbol = function(symbol) {
            editor.selection.insertHTML(symbol);
            document.body.removeChild(modal);
          };
        }
      },
      {
        name: "math",
        tooltip: "Insert LaTeX",
        exec: (editor) => {
          const latexInput = prompt("Enter LaTeX expression:");
          if (latexInput) {
            const filteredInput = latexInput.replace(/^\\?\[|\\]$/g, '').trim();
            try {
              const renderedLatex = katex.renderToString(filteredInput, {
                throwOnError: false,
                displayMode: false, // Optional: controls whether LaTeX is displayed inline or block
                output: 'mathml' // We only need the MathML part
              });
              editor.selection.insertHTML(renderedLatex);
            } catch (error) {
              alert("Invalid LaTeX expression.");
            }
          }
        },
      }

    ],
    disablePlugins: ["speech"],
    toolbarAdaptive: false, 
  }
  const editorConfig={
    readonly: false,
    tabIndex: 1,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    placeholder: "Type your description here ...",
    beautyHTML: true,
    toolbarButtonSize: "small",
    addNewLine: false,
    buttons: [
      "bold",
      "italic",
      'subscript', 
      'superscript',
      "|",
      "ul",
      "ol",
      "|",
      "font",
      "fontsize",
      "brush",
      "|",
      "table",
      "|",
      "left",
      "center",
      "right",
      "justify",
      "|",
      "undo",
      "redo",
      "|",
      "hr",
      "fullsize", 
    ],
    extraButtons: [
      {
        name: "symbols",
        icon: "fa fa-smile-o",
        tooltip: "Insert Symbol",
        exec: (editor) => {
          // Define the custom symbols
          const customSymbols = [
            { symbol: '€', title: 'Euro' },
            { symbol: '£', title: 'Pound Sterling' },
            { symbol: '¥', title: 'Yen' },
            { symbol: '₹', title: 'Indian Rupee' },
            { symbol: '$', title: 'Dollar' },
            { symbol: '₣', title: 'Franc' },
            { symbol: '₣', title: 'Lira (Turkish)' },
            { symbol: '±', title: 'Plus-Minus' },
            { symbol: '÷', title: 'Division Sign' },
            { symbol: '×', title: 'Multiplication Sign' },
            { symbol: '≠', title: 'Not Equal' },
            { symbol: '≈', title: 'Approximate Equal' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '√', title: 'Square Root' },
            { symbol: 'π', title: 'Pi' },
            { symbol: '∑', title: 'Summation' },
            { symbol: '∏', title: 'Product' },
            { symbol: '∈', title: 'Element Of' },
            { symbol: '∩', title: 'Intersection' },
            { symbol: '∪', title: 'Union' },
            { symbol: '∧', title: 'Logical AND' },
            { symbol: '∨', title: 'Logical OR' },
            { symbol: 'α', title: 'Alpha' },
            { symbol: 'β', title: 'Beta' },
            { symbol: 'γ', title: 'Gamma' },
            { symbol: 'δ', title: 'Delta' },
            { symbol: 'ε', title: 'Epsilon' },
            { symbol: 'λ', title: 'Lambda' },
            { symbol: 'μ', title: 'Mu' },
            { symbol: 'σ', title: 'Sigma' },
            { symbol: 'τ', title: 'Tau' },
            { symbol: 'φ', title: 'Phi' },
            { symbol: 'Ω', title: 'Omega' },
            { symbol: '©', title: 'Copyright' },
            { symbol: '®', title: 'Registered Trademark' },
            { symbol: '™', title: 'Trademark' },
            { symbol: '♥', title: 'Heart' },
            { symbol: '★', title: 'Star' },
            { symbol: '☼', title: 'Sun' },
            { symbol: '☽', title: 'Crescent Moon' },
            { symbol: '☃', title: 'Snowman' },
            { symbol: '☠', title: 'Skull and Crossbones' },
            { symbol: '✈', title: 'Airplane' },
            { symbol: '⚡', title: 'High Voltage' },
            { symbol: '✿', title: 'Flower' },
            { symbol: '☘', title: 'Shamrock' },
            { symbol: '☀', title: 'Sun Symbol' },
            { symbol: '☁', title: 'Cloud Symbol' },
            { symbol: '☂', title: 'Umbrella Symbol' },
            { symbol: '→', title: 'Right Arrow' },
            { symbol: '←', title: 'Left Arrow' },
            { symbol: '↑', title: 'Up Arrow' },
            { symbol: '↓', title: 'Down Arrow' },
            { symbol: '↔', title: 'Left-Right Arrow' },
            { symbol: '↕', title: 'Up-Down Arrow' },
            { symbol: '↗', title: 'Up-Right Arrow' },
            { symbol: '↖', title: 'Up-Left Arrow' },
            { symbol: '§', title: 'Section Symbol' },
            { symbol: '¶', title: 'Paragraph Symbol' },
            { symbol: '°', title: 'Degree Symbol' },
            { symbol: '≡', title: 'Identical To' },
            { symbol: '∞', title: 'Infinity' },
            { symbol: '≠', title: 'Not Equal' }
          ];
          

          // Build the HTML content for the custom symbols
          const symbolButtons = customSymbols
            .map(
              (symbol) =>
                `<button class="jodit-symbol-btn" title="${symbol.title}" onclick="insertSymbol('${symbol.symbol}')">${symbol.symbol}</button>`
            )
            .join(" ");

          // Show a modal to select a symbol
          const modal = document.createElement('div');
          modal.classList.add('jodit-symbol-modal');
          modal.innerHTML = `
            <div class="jodit-symbol-modal-content">
              <h3>Select a Symbol</h3>
              <div class="symbol-buttons">${symbolButtons}</div>
              <button class="jodit-close-btn">Close</button>
            </div>
          `;
          document.body.appendChild(modal);

          // Close modal handler
          modal.querySelector('.jodit-close-btn').addEventListener('click', () => {
            document.body.removeChild(modal);
          });

          // Insert the symbol into the editor
          window.insertSymbol = function(symbol) {
            editor.selection.insertHTML(symbol);
            document.body.removeChild(modal);
          };
        }
      },
      // {
      //   name: "image",
      //   tooltip: "Insert Image",
      //   exec: (editor) => {
      //     const input = document.createElement("input");
      //     input.type = "file";
      //     input.accept = "image/*";
      //     input.addEventListener("change", async (e) => {
      //       const file = e.target.files[0]; // Get the file from the input
        
      //       if (file) {
      //         // Create FormData to send the file to the backend
      //         const formData = new FormData();
      //         formData.append("file", file); // Append the image file
        
      //         try {
      //           // Send the image to the backend server
      //           const response = await axios.post(`${baseUrl}/question/upload-image`, formData, {
      //             headers: {
      //               "Content-Type": "multipart/form-data", // Ensure the correct content type
      //             },
      //           });

      //           const imageUrl = response.data.url;
        
      //           // Insert the uploaded image URL into the Jodit editor
      //           editor.selection.insertImage(imageUrl);
      //         } catch (err) {
      //           console.error("Error uploading image:", err);
      //         }
      //       }
      //     });
      //     input.click();
      //   },
      // },
      {
        name: "math",
        tooltip: "Insert LaTeX",
        exec: (editor) => {
          const latexInput = prompt("Enter LaTeX expression:");
          console.log(latexInput)
          const filteredInput = latexInput.replace(/^\\?\[|\\]$/g, '').trim();
          if (latexInput) {
            try {
              const renderedLatex = katex.renderToString(filteredInput, {
                throwOnError: false,
                displayMode: false, // Optional: controls whether LaTeX is displayed inline or block
                output: 'mathml' // We only need the MathML part
              });
              editor.selection.insertHTML(renderedLatex);
            } catch (error) {
              alert("Invalid LaTeX expression.");
            }
          }
        },
      } 
    ],
    disablePlugins: ["speech"],
    toolbarAdaptive: false, 
  }

const handleQuestionContent = (newContent) => {
  if (questionContentRef.current) {
    if (newContent === "") {
      questionContentRef.current = "<p></p>";
    } else {
      questionContentRef.current = newContent;
    }
  }
};

  const handleAnswerContent = (newContent) => {
    if (answerContentRef.current) {
      if (newContent === "") {
        answerContentRef.current = "<p></p>";
      } else {
        answerContentRef.current = newContent;
      }
    }
  };

   useEffect(() => {
        const timer = setTimeout(() => {
          setMessage(false);
        }, 4000);
        return () => clearTimeout(timer);
      }, [message]);


  useEffect(() => {
    axios.get(`${baseUrl}/subject/all`)
    .then(res=>setSubjects(res.data))
    .catch(err=>console.log(err))
  }, []);
  useEffect(() => {
    setExamsLoading(true)

    // Fetch exams based on selected classes
    axios.get(`${baseUrl}/exam/get/by-class?className=${selectedClass}`)
      .then(res => {
        setExams(res.data.data);
        setExamsLoading(false)
      })
      .catch(err => {
        console.error("Error fetching exams: ", err);
        setExams([])
        setExamsLoading(false)
      });
  }, [selectedClass]);
  const data =
  mode === "exam"
    ? {
        correct,
        subject,
        className: selectedClass,
        exams: selectedExams
      }
    : {
        correct,
        subject,
        topic,
        difficulty
      };

  const handleSubmit = () => {
    if(questionContentRef.current==="<p><br></p>"){
      setMessage("Please Enter question")
      return
    }
    if(answerContentRef.current==="<p><br></p>"){
      setMessage("Please Enter answer")
      return
    }
    if(option1Ref.current==="<p><br></p>"){
      setMessage("Please Enter option 1")
      return
    }
    if(option2Ref.current==="<p><br></p>"){
      setMessage("Please Enter option 2")
      return
    }
    if(option3Ref.current==="<p><br></p>"){
      setMessage("Please Enter option 3")
      return
    }
    if(option4Ref.current==="<p><br></p>"){
      setMessage("Please Enter option 4")
      return
    }
    if (correct === "") {
      setMessage("Please Select correct option")
      return
    }

    if (mode === "exam") {
      if (selectedExams.length === 0) {
        setMessage("Please select exam");
        return;
      }
      if (!selectedClass) {
        setMessage("Please select class");
        return;
      }
    }

    if (mode === "topic") {
      if (!subject) {
        setMessage("Please select subject");
        return;
      }
      if (!topic) {
        setMessage("Please select topic");
        return;
      }
      if (!difficulty) {
        setMessage("Please select difficulty");
        return;
      }
    }

    if (selectedExams.length > 0 && selectedClass === "") {
      setMessage("Please select class for exam");
      return;
    }

    if (topic && !subject) {
      setMessage("Please select subject for topic");
      return;
    }

    if (topic && !difficulty) {
      setMessage("Please select difficulty");
      return;
    }
    setAddLoading(true)

      api.post(`${baseUrl}/question/create`, {...data,options,question:questionContentRef.current, answer:answerContentRef.current}).then((res) => {
          toast.success(res?.data?.message)
          setEditorKey(Date.now())
          setCorrect("")
          setAddLoading(false)
      })
      .catch(err=>{
        toast.error(err?.response?.data?.message || "Something went wrong")
        setAddLoading(false)})
    };

  useEffect(() => {
    if (subject) {
      axios
        .get(`${baseUrl}/topic/by-subject?subject=${subject}`)
        .then((res) => setTopics(res.data))
        .catch((err) => console.log(err));
    } else {
      setTopics([]);
    }
  }, [subject]);

  useEffect(() => {
    setSelectedExams([]);
    setTopic("");
    setSubject("");
    setDifficulty("");
  }, [mode]);

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link className="text-decoration-none">Questions</Link>
              </li>
              <li className="breadcrumb-item active">
                Add
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div className="mb-3">
          <label className="form-label fs-5">Select Mode :</label>
          <div>
            <button
              className={`btn btn-sm me-2 ${mode === "exam" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => setMode("exam")}
            >
              Exam Wise
            </button>

            <button
              className={`btn btn-sm ${mode === "topic" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => setMode("topic")}
            >
              Topic Wise
            </button>
          </div>
        </div>

        <div className={`container-fluid`}>
          <div className="bg-white p-4">
            <h4 className="mb-3">Add Question :</h4>
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <label htmlFor="question" className="form-label fs-4">
                    Question :
                  </label>
                  <JoditReact
                    key={editorKey}
                    ref={questionContentRef}
                    config={{
                      ...editorConfig,
                      placeholder:'Enter Question',
                    }}
                    onChange={handleQuestionContent}
                  />
                </div>
                <div className="row">
                  <label htmlFor="solution" className="form-label fs-4">
                    Solution :
                  </label>
                  <JoditReact
                    key={editorKey}
                    ref={answerContentRef}
                    config={{
                      ...editorConfig,
                      placeholder:'Enter Answer',
                    }}
                    onChange={handleAnswerContent}
                  />
                </div>
              </div>
              <div className="col-lg-5">
              {/* <label htmlFor="options" className="form-label fs-4">
                  Options :
                </label> */}
                {
                    options.map((o,i)=>
                      <div key={i} className="col">
                    <label htmlFor={`option${i+1}`} className="form-label">
                      {`Option ${i+1} :`}
                    </label>
                    <JoditReact
                    key={editorKey}
                      ref={o}
                      config={{
                        ...editorConfig2, 
                        minHeight:110,
                        height: 110,
                        placeholder: `Option : ${i+1}`,
                      }}
                      onChange={(newContent) => {
                        if (o.current) {
                          // Ensure that the ref is updated with new content, even when it's empty
                          if (newContent === "") {
                            o.current = "<p></p>"; // If the content is cleared, make sure the ref is set to an empty string
                          } else {
                            o.current = newContent; // Otherwise, set it to the new content
                          }
                        }
                      }}
                    />
                  </div>
                    )
                  }

              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-3">
                <label htmlFor="correct" className="form-label fs-4">
                  Correct :
                </label>
                <select
                  className="form-select"
                  id="correctAnswer"
                  value={correct}
                  onChange={(e) => setCorrect(e.target.value)}
                  required
                >
                  <option value="" hidden>Select correct</option>
                  {[...Array(4)].map((option, index) => (
                    <option key={index} value={index + 1}>
                      Option {index + 1}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-3">
              <label htmlFor="subject" className="form-label fs-4">
                  Subject :
                </label>
                <select
                  className="form-select"
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                >
                  <option value="" hidden>Select Subject</option>
                  {subjects.map((c, index) => (
                    <option key={index}>
                      {c.subjectName}
                    </option>
                  ))}
                </select>
              </div>
              {mode === "topic" && (
                <>
                  <div className="col-lg-3">
                    <label className="form-label fs-4">Topic :</label>
                    <select
                      className="form-select"
                      value={topic}
                      onChange={(e) => setTopic(e.target.value)}
                    >
                      <option value="" hidden>Select Topic</option>
                      {topics.map((t) => (
                        <option key={t._id} value={t._id}>
                          {t.topicName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-3">
                    <label className="form-label fs-4">Difficulty :</label>
                    <select
                      className="form-select"
                      value={difficulty}
                      onChange={(e) => setDifficulty(e.target.value)}
                    >
                      <option value="" hidden>Select Difficulty</option>
                      <option value="easy">Easy</option>
                      <option value="medium">Medium</option>
                      <option value="hard">Hard</option>
                    </select>
                  </div>
                </>
              )}

            </div>
            {mode === "exam" && (

            <div className="row mt-4">
            <div className="col-lg-3">
              <label htmlFor="class" className="form-label fs-4">
                  Class :
                </label>
                <select
                  className="form-select"
                  id="class"
                  value={selectedClass}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedClass(value);
                  }}
                  required
                >
                  <option value="" hidden>Select Class</option>
                    <option>
                      Class XI
                    </option>
                    <option>
                      Class XII
                    </option>
                    <option>
                      Class XII Passed
                    </option>
                </select>
              </div>
            <div className="col-lg-6">
                <label htmlFor="exam" className="form-label">
                  Select Exam
                </label>
                {
                  examsLoading&&
                  <><br/><img src="/assets/images/load-time.gif" width='50px' alt="loading"/></>
                }
                {
                  !examsLoading&&exams.length>0&&
                  <select
                  className="form-select"
                  id="exam"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedExams((prev) =>
                      prev.includes(value) ? prev.filter((id) => id !== value) : [...prev, value]
                    );
                  }}
                  multiple
                  value={selectedExams}
                >
                  {
                    exams.map((e) => (
                      <option key={e._id} value={e._id}>
                        {e.examName} ({e.className})
                      </option>
                    ))
                  } 
                </select>
                }
                {
                  !examsLoading&&exams.length<1&&
                    <p className="text-danger">
                      No active exam found for selected class
                    </p>
                }
              </div>
            </div>
            )}
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button disabled={addLoading} onClick={handleSubmit} className="btn btn-primary mt-4 btn-sm">
              {
                addLoading ? 'Processing ...' : 'Add'
              }
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AddQuestion;
